import React, { ReactNode } from "react";

interface RadioButtonClasses {
    checkMark?: string;
    container?: string;
    inputContainer?: string;
    input?: string;
    label?: string;
}

interface RadioButtonProps {
    labelText: string | JSX.Element;
    classes?: RadioButtonClasses;
    inputId: string;
    inputProps?: React.HTMLProps<HTMLInputElement>;
    onChange?: () => void;
}

const BaseRadioButton = (props: RadioButtonProps) => {
    const {
        labelText, classes, inputId, inputProps, onChange
    } = props;
    return (
        <label className={classes?.container} htmlFor={inputId}>
            <span className={classes?.inputContainer}>
                <input type="radio" className={classes?.input} id={inputId} onChange={onChange} {...inputProps} />
                <span className={classes?.checkMark} />
            </span>
            <span className={classes?.label}>{labelText}</span>
        </label>
    );
};

export { BaseRadioButton as default };
export type { RadioButtonProps, RadioButtonClasses };
